import '@fancyapps/fancybox';
import 'slick-carousel';
import 'jquery-match-height/jquery.matchHeight.js';
import 'page-scroll-to-id/jquery.malihu.PageScroll2id.js';
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import Inputmask from "inputmask";

$('.btn-menu').click(function(){
  $('.mobile-menu').slideToggle(200).toggleClass('active');
  $(this).toggleClass('open')
});

$('.mobile-menu a').click(function(){
  $('.mobile-menu').slideUp(200).removeClass('active');
  $('.btn-menu').removeClass('open');
});

$('.scroll-to').mPageScroll2id();

$('.load-more').click(function(){
    $(this).addClass("hidden");
    $('.about-section__hidden').fadeIn();
})

$('.close-btn').click(function(){
    $(this).fadeIn();
    $('.about-section__hidden').fadeOut();
    $('.load-more').removeClass("hidden");
});

$('.reviews-slider').slick({
    slidesToShow: 3,
    infinite: false,
    prevArrow: '<div class="reviews-slider__arrow-prev"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 407.436 407.436" style="enable-background:new 0 0 407.436 407.436;" xml:space="preserve"><polygon points="315.869,21.178 294.621,0 91.566,203.718 294.621,407.436 315.869,386.258 133.924,203.718 "/></svg></div>',
    nextArrow: '<div class="reviews-slider__arrow-next"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 407.436 407.436" style="enable-background:new 0 0 407.436 407.436;" xml:space="preserve"><polygon points="112.814,0 91.566,21.178 273.512,203.718 91.566,386.258 112.814,407.436 315.869,203.718 "/></svg></div>',
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        }
      },
    ]
});

if($(window).width() < 767)
  {
    $('.service-card').click(function(){

      var item = $(this).data('tab');

      $(this).addClass('active');
      $('#service-card__hidden-' + item).fadeIn();

    });

    $('.hidden-btn').click(function(){
      $('.service-card').removeClass('active');
      $('.service-card__hidden').hide();
    });

  } else {
    $('.service-card').hover(function(){

      var item = $(this).data('tab');

      $('#service-item-' + item).fadeIn();

    });

    $('.service-item').mouseleave(function(){

      $(this).fadeOut();

    });
  }

  $('.play-video').click(function(){
    $('.video-screen').addClass("show");
    $('#video').get(0).play();
    if ("ontouchstart" in document.documentElement) {
      $('body, html').addClass('disable-scroll');
    } else {
      disableBodyScroll();
    }
  });

  $('.video-container__close').click(function(){
    $('.video-screen').removeClass("show");
    $('#video').trigger('pause');
    if ("ontouchstart" in document.documentElement) {
      $('body, html').removeClass('disable-scroll');
    } else {
      enableBodyScroll();
    }
  });

$(document).ready(function() {

  Inputmask("+ 38 (099) 999-99-99").mask('.input_phone');
  Inputmask({ regex: "[a-zA-Z-а-яА-Я- ]*"}).mask('.input_name_mask');

  function heightDetect() {
    $('.billbord-thanks').css("min-height", $(window).height() - $(".header").height() - $(".footer").height());
  };
  heightDetect();
  $(window).resize(function() {
    heightDetect();
  });

  //Попап менеджер FancyBox
  $(".fancybox").fancybox();

});

$(document).on('click', '#front_button', function() {
  var form_name = $( "input[name*='front_name']" ).val();
  var form_phone= $( "input[name*='front_phone']" ).val();
  if(form_name != "" && form_phone != ""){

    var data = {
      form_name:form_name,
      form_phone:form_phone,
      action: 'form_send_mail'

    }

    $.ajax({
      url: document.location.origin+'/wp-admin/admin-ajax.php',
      type: 'POST',
      data: data,
      success: function( data ) {
        document.location.href=document.location.origin+"/thank-you-page?sname="+form_name+"&sphone="+form_phone
      }

    });

  }
  else alert( "Пожалуйста заполните все поля." );
  return false;
});

$(document).on('click', '#modal_button', function() {
  var form_name = $( "input[name*='modal_name']" ).val();
  var form_phone= $( "input[name*='modal_phone']" ).val();
  if(form_name != "" && form_phone != ""){

    var data = {
      form_name:form_name,
      form_phone:form_phone,
      action: 'form_send_mail'

    }

    $.ajax({
      url: document.location.origin+'/wp-admin/admin-ajax.php',
      type: 'POST',
      data: data,
      success: function( data ) {
        document.location.href=document.location.origin+"/thank-you-page?sname="+form_name+"&sphone="+form_phone
      }

    });

  }
  else alert( "Пожалуйста заполните все поля." );
  return false;
});

